import { render } from "./mvt-inputdate.vue?vue&type=template&id=2c957c20"
import script from "./mvt-inputdate.js?vue&type=script&lang=js"
export * from "./mvt-inputdate.js?vue&type=script&lang=js"

import exportComponent from "/builds/movoto/frontend/consumer-web/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__